import { render, staticRenderFns } from "./TopicAdmin.vue?vue&type=template&id=06176f85&"
import script from "./TopicAdmin.vue?vue&type=script&lang=ts&"
export * from "./TopicAdmin.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/components/admin/topic-admin.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports